import React, { useState, useEffect } from "react";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import Table from "../../../UI/Table/Table";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MasterDeleteModal from "../../../UI/Model/MasterDeleteModel/MasterDeleteModel";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";

function ViewCustomers({ showProduct }) {
  const [Tbody, setTbody] = useState([
    {
      customer_name: "sahil",
      address: "bhaktapur",
      email: "sahilsainju22@gmail.com",
      phone_no: "9876567654",
    },
    {
      customer_name: "sainju",
      address: "bhaktapur,thimi",
      email: "sahilsainju22@gmail.com",
      phone_no: "9876567654",
    },
    {
      customer_name: "shrestha",
      address: "kathmandu",
      email: "sahilsainju22@gmail.com",
      phone_no: "9876567654",
    },
  ]);
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [ID, setID] = useState("");
  const [storeID, setStoreID] = useState(false);
  const tHead = [
    { title: "s.nO", width: "10%" },
    { title: "customer Name", width: "20%" },
    { title: "address", width: "10%" },
    { title: "contact Number", width: "10%" },
    { title: "email", width: "10%" },
    { title: "action", width: "30%" },
  ];
  const getCustomers = () => {
    axios
      .get("/customer")
      .then((res) => {
        console.log(res.data.result);
        // setTbody(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getCustomers();
  }, []);
  const Schema = yup.object().shape({
    customer_name: yup.string().required("Customer Name is required"),
    email: yup.string().required("Email is required"),
    address: yup.string().required("Address is required"),
    phone_no: yup.string().required("Phone Number is required"),
    // allData: yup.string().required("Email is required"),
  });
  const billingFormData = [
    {
      type: "text",
      placeholder: "Customer's Name ",
      apikey: "customer_name",
      label: "customer name",
    },
    {
      type: "email",
      placeholder: "Customer's Email ",
      apikey: "email",
      label: "customer email",
    },
    {
      type: "text",
      placeholder: "Phone Number ",
      apikey: "phone_no",
      label: "phone number",
      // icon: <BsFillTelephoneFill className="h-5 w-5 " />,
    },
    {
      type: "text",
      placeholder: "Address ",
      apikey: "address",
      label: " address",
      // icon: <HiLocationMarker className="h-6 w-6" />,
    },
  ];

  const DeleteItems = () => {
    // console.log(idStore);
    axios
      .delete(`/brand/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          setMessage(false);

          getCustomers(idStore);
          toast.error(res ? res?.data?.message : "");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
    // console.log(id);
  };
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        // id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const Edit = (values) => {
    setID(values);
    setShowModel(true);
    // console.log(values);
    // setStoreImage([...values.image]);
  };
  // console.log(ID);
  useEffect(() => {
    setStoreID(ID);
  }, [ID, storeID]);

  const Submits = (value) => {
    // value.details = storeDescription;
    setShowModel(false);
    console.log(value);
    // value.name = ID.name;
    // value.tId = ID.tId;
    // value.createdAt = ID.createdAt;
    // console.log(value);
    // axios
    //   .patch(`/customer/${ID.id}`, value)
    //   .then((res) => {
    //     console.log(res);
    //     if (res.status === 201) {
    //       setShowAttendence(false);
    //       setStoreDescription("");
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  let mod;
  mod = (
    <div
      className={`${
        showModel ? " absolute  z-50 top-0 bottom-0 right-0 left-0" : ""
      }`}
    >
      <div
        className={` ${
          showModel ? "translate-y-0 " : "-translate-y-full "
        }  duration-700 delay-300 ease-in-out fixed top-0 bottom-0 right-0 left-0  z-40 `}
      >
        <div
          className=" relative z-50 bg-[white] rounded-md top-[18%]  flex 
         p-5 w-7/12 mx-auto h-fit "
        >
          <div className="w-[95%] my-4">
            <Formik
              initialValues={{
                customer_name: ID?.customer_name ? ID?.customer_name : "",
                email: ID?.email ? ID?.email : "",
                address: ID?.address ? ID?.address : "",
                phone_no: ID?.phone_no ? ID?.phone_no : "",
                //   TotalPrice: "",
                //   allData: "",
              }}
              validationSchema={Schema}
              onSubmit={(values, { resetForm }) => {
                // console.log(values);
                Submits(values);
                resetForm();
              }}
            >
              {({ values, errors, touched, handleSumit, isSubmitting }) => (
                <Form>
                  <div className={`   gap-6`}>
                    {billingFormData?.map((val, i) => {
                      if (val.sub) {
                        return (
                          <div
                            className="laptop:grid grid-cols-2 gap-5"
                            key={i}
                          >
                            {val.sub.map((val, i) => {
                              return (
                                <div key={i} className="laptop:w-full   my-5">
                                  <div className="capitalize  my-2">
                                    <label
                                      className="cursor-pointer font-semibold text-gray-600"
                                      htmlFor={val.apikey}
                                    >
                                      {val.label}
                                    </label>
                                  </div>
                                  <div className="relative">
                                    <label htmlFor={val.apikey}>
                                      {" "}
                                      <div className="absolute top-3  cursor-pointer left-2 text-gray-300 bg-opacity-80">
                                        {val.icon}
                                      </div>
                                    </label>
                                    <Field
                                      id={val.apikey}
                                      placeholder={val.placeholder}
                                      name={val.apikey}
                                      className="border border-gray-300 px-3 py-2.5 w-11/12 laptop:w-full rounded-md"
                                    />
                                  </div>
                                  <div
                                    className={`${
                                      errors[val.apikey] && touched[val.apikey]
                                        ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                        : ""
                                    }`}
                                  >
                                    {errors[val.apikey] && touched[val.apikey]
                                      ? errors[val.apikey]
                                      : ""}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      } else {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>
                            <div className="relative">
                              <label htmlFor={val.apikey}>
                                {" "}
                                {/* <div className="absolute top-2.5 cursor-pointer left-1 text-gray-300 bg-opacity-80">
                                  <IoIosPeople className="h-7 w-7" />
                                </div> */}
                              </label>
                              <Field
                                id={val.apikey}
                                placeholder={val.placeholder}
                                name={val.apikey}
                                className="border border-gray-300 px-3 py-2.5  w-11/12 laptop:w-full rounded-md"
                              />
                            </div>
                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  <div className="flex justify-start  mt-5 w-11/12">
                    <button
                      type="submit"
                      className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
                    >
                      submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div
            className="absolute top-5 border border-gray-600  text-gray-600 bg-white  
            hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer right-10"
            onClick={() => {
              setShowModel(false);
              setID(null);
              // setStoreImage([]);
            }}
          >
            <MdClose />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  return (
    <div className=" p-6">
      <div
        className={`${
          showModel
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showModel ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showModel ? mod : ""}{" "}
        </div>
      </div>
      <Table celspacing={0} cellPadding={0} Head={tHead}>
        {Tbody.map((val, i) => {
          return (
            <tr key={i} className=" w-full font-medium text-gray-700">
              <td className="border-b p-2 text-center"> {i + 1}</td>

              <td className="border-b p-2 text-center capitalize  ">
                {val.customer_name}
              </td>

              <td className="border-b p-2 text-center capitalize">
                {val.address}
              </td>
              <td className="border-b p-2 text-center capitalize">
                {val.phone_no}
              </td>
              <td className="border-b p-2 ">
                <div className="  ml-10 ">{val.email} </div>
              </td>
              <td className="border-b p-2 text-center">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}

export default ViewCustomers;
